export default __webpack_public_path__ + "locales/si/PrivacyPage.json?hash=6c3f41086cf0d24179cb5526b12a84fb";